import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthorizationService} from '../../authorization/authorization.service';
import {FilterMenuPopoverOption} from '../filter-menu-popover/filter-menu-popover.component';
import {ImmutableListRepositoryService} from '../../../lib/gelios-field/immutable-list-repository.service';
import {UnitHelper} from '../utils/unit.helper';

@Component({
  selector: 'app-unit-type-filter',
  templateUrl: './unit-type-filter.component.html'
})
export class UnitTypeFilterComponent implements OnInit {
  @Input() selectedType = 'showAll';
  @Output() selectedTypeChange = new EventEmitter<string>();

  options: FilterMenuPopoverOption[] = [];

  get currentIconClass(): string {
    const item = this.options.find(f => f.key === this.selectedType);
    return item ? item.iconClass || '' : '';
  }

  constructor(
    private authorizationService: AuthorizationService,
    private immutableList: ImmutableListRepositoryService
  ) {
  }

  ngOnInit() {
    UnitHelper.buildUnitTypeOptions(this.authorizationService, this.immutableList, 'id')
      .subscribe(options => this.options = options);
  }

  onSelectionChange(key: string) {
    this.selectedType = key;
    this.selectedTypeChange.emit(this.selectedType);
  }
}
